import { ResourcesConfig } from "aws-amplify";

//
// AWS Amplify / Cognito
//
export const AMPLIFY_CONFIG: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
    },
  },
};

//
// Innovasea services
//
export const FILE_SERVER_URL = process.env.REACT_APP_FILE_SERVER_URL;

export const DATA_SERVER_URL = process.env.REACT_APP_DATA_SERVER_URL;

export const GQL_SERVER_URL = process.env.REACT_APP_GQL_SERVER_URL;

export const FATHOM_POSITION_URL = process.env.REACT_APP_FATHOM_POSITION_URL;

export const VEMCO_LIVE_URL = process.env.REACT_APP_VEMCO_LIVE_URL;

export const SYSTEM_MANAGER_URL = process.env.REACT_APP_SYSTEM_MANAGER_URL;

export const LOGROCKET_URL = process.env.REACT_APP_LOGROCKET;

// External APIs
export const MapboxToken =
  "pk.eyJ1IjoiZnJhbmtzbWl0aCIsImEiOiJjanRwbnpzdGYwNm5jM3ltMjU0ZHp2MnhqIn0.mRK6Sv3AtWDfNIFKvLRQsw";

// Control Variables
export const FILE_SERVER_ACTIONS_DISABLED =
  process.env.REACT_APP_FILE_SERVER_ACTIONS_DISABLED === "true";
